"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin } from "lucide-react";
export default function Karta() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="карта" ref={sectionRef} className="relative py-16 md:py-24 bg-background overflow-hidden">
      <div className="container">
        <div className={`relative w-full h-[500px] md:h-[600px] rounded-lg overflow-hidden shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          {}
          <div className="absolute inset-0 w-full h-full">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2933.568326462445!2d23.273822176587443!3d42.67055591544321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa84e4f6a97871%3A0x6d8b9f1d0b0a0a0a!2z0LHRg9C7LiDigJ7QptCw0YAg0JHQvtGA0LjRgSBJSUnigJwgMTU5LCAxNjE4INC60LIuINCR0YrQutGB0YLQvtC9LCDQodC-0YTQuNGP!5e0!3m2!1sbg!2sbg!4v1710000000000!5m2!1sbg!2sbg" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Местоположение на Миш-Маш /интерпред/" className="grayscale-[0.2] contrast-[1.1]"></iframe>
            {}
            <div className="absolute inset-0 bg-primary/5 pointer-events-none"></div>
          </div>

          <div className="absolute inset-0 transition-transform duration-500 ease-[var(--ease-smooth)] hover:scale-105 pointer-events-none"></div>
        </div>

        <div className={`mt-8 mx-auto max-w-2xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-150 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <div className="card p-6 md:p-8">
            <h3 className="text-[26px] font-display font-bold mb-4 text-foreground">
              Как да ни намерите
            </h3>
            <div className="space-y-3 text-foreground/80">
              <p className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span><strong data-ast-id="f:/src/pages/Contact/sections/Karta.tsx|sig:wold8i" data-ast-start="2694" data-ast-end="2717">Адрес:</strong>&nbsp;бул. Цар Борис III 159</span>
              </p>
              <div className="text-sm leading-relaxed">
                <p>Намираме се в ж.к. Бъкстон (Красно село), на бул. „Цар Борис III“ 159 – в сградата на Бизнес център Интерпред.</p>
                <p className="mt-2">Лесен достъп с метро – станция „Бул. Цар Борис III / Красно село“ е на 5-7 минути пеша.</p>
                <p className="mt-2">Много автобусни линии спират наблизо (напр. спирки Ж.к. Бъкстон, 10-ти километър или Околовръстен път), а има и трамвайни линии в района.</p>
                <p className="mt-2">Паркирането е удобно - в близките странични улици или в околните подземни/надземни паркинги на бизнес центъра.</p>
              </div>
              <p className="text-sm leading-relaxed mt-4 text-muted-foreground">При нужда от насоки или резервация, моля свържете се с нас на телефон +359 888 007 342 или на имейл mishmashinterpred.orders@gmail.com.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent pointer-events-none"></div>
    </section>;
}